export type PdfDocumentAction = "print" | "download";

const STORAGE_KEY = "xgs-pdf-document-action";
const DEFAULT_ACTION: PdfDocumentAction = "print";

type PdfDocumentActionListener = (action: PdfDocumentAction) => void;

const listeners = new Set<PdfDocumentActionListener>();

const isValidAction = (value: unknown): value is PdfDocumentAction =>
  value === "print" || value === "download";

export const getPdfDocumentAction = (): PdfDocumentAction => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (isValidAction(raw)) return raw;
  } catch {
    // ignore storage read failures
  }
  return DEFAULT_ACTION;
};

export const setPdfDocumentAction = (action: PdfDocumentAction): void => {
  if (!isValidAction(action)) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, action);
  } catch {
    // ignore storage write failures
  }
  listeners.forEach((listener) => listener(action));
};

export const subscribePdfDocumentAction = (
  listener: PdfDocumentActionListener
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
